import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    console.log("Geolocation controller connected")
  }

  detect(event) {
    if (event) event.preventDefault()
    
    const button = event.currentTarget
    const originalContent = button.innerHTML
    
    // Add loading state
    button.disabled = true
    button.innerHTML = `
      <svg class="animate-spin h-5 w-5 mr-3 text-blue-600" viewBox="0 0 24 24">
        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4" fill="none"></circle>
        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
      </svg>
      Finding...
    `

    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const lat = position.coords.latitude;
          const lng = position.coords.longitude;
          
          const url = new URL(window.location.href);
          url.searchParams.set('lat', lat);
          url.searchParams.set('lng', lng);
          
          window.location.href = url.toString();
        },
        (error) => {
          console.error("Geolocation error:", error.message);
          button.disabled = false
          button.innerHTML = originalContent
          alert("Could not get your location. Please check your browser settings.")
        }
      );
    } else {
      alert("Geolocation is not supported by your browser.")
      button.disabled = false
      button.innerHTML = originalContent
    }
  }
}
